/* eslint-disable no-continue */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */

/**
 * Update a form field from an ajax request response
 * @param {Object} element - Form field to update
 * @param {String} value
 * @param {String} format - "data_type" from gui_def
 * @param {string} pannel_id
 */
window.setFormFieldValue = function setFormFieldValue(element, value, format, pannel_id) {
  if (!window.isObjectValid(element)) {
    element = window.xGetElementById(element);
  }
  if (element.type === 'checkbox') {
    const str_value = value.toLowerCase();
    if (str_value === 'on' || str_value === 'true' || str_value === '1' || str_value === 'yes') {
      element.setAttribute('checked', 'checked');
      element.checked = true;
    } else {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
      element.setAttribute('checked', false);
      element.checked = false;
    }
  } else if (
    (element.type === 'number' || element.type === 'text') &&
    (format === 'money' || format === 'prettymoney')
  ) {
    // strip out '$' etc
    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'getMoney'.
    element.value = getMoney(value).toFixed(2);
  } else {
    element.value = value;
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'HTMLInp... Remove this comment to see the full error message
  if (element.options && element.selectedIndex) {
    try {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'HTMLInp... Remove this comment to see the full error message
      element.options[element.selectedIndex].setAttribute('selected', 'selected');
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'HTMLInp... Remove this comment to see the full error message
      element.options[element.selectedIndex].selected = true;
    } catch (e) {} // eslint-disable-line no-empty
  }

  // CLD-12298 When the callback is received and the field is updated,
  // "has_changed" flag and the need to save the current panel should be removed
  if (/has_changed/.test(element.className)) {
    element.className = element.className.replace('has_changed', '');
    if (
      pannel_id &&
      window.do_saves &&
      // @ts-expect-error ts-migrate(2538) FIXME: Type 'HTMLElement' cannot be used as an index type... Remove this comment to see the full error message
      window.do_saves[pannel_id] &&
      !$(`#${pannel_id} .has_changed`)[0]
    ) {
      // @ts-expect-error ts-migrate(2538) FIXME: Type 'HTMLElement' cannot be used as an index type... Remove this comment to see the full error message
      delete window.do_saves[pannel_id];
    }
  }
};

window.getFormFieldValue = function getFormFieldValue(element) {
  if (!window.isObjectValid(element)) element = window.xGetElementById(element);

  if (element.type === 'checkbox') {
    if (element.checked) return 'on';
    return 'off';
  }
  if (element.type === 'select-multiple') {
    const selected = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'HTMLInp... Remove this comment to see the full error message
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < element.options.length; i++) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'HTMLInp... Remove this comment to see the full error message
      if (element.options[i].selected) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        selected[i] = element.options[i].value;
      }
    }
    return selected;
  }
  if (element.classList.contains('isValueJsonEncoded')) {
    try {
      return JSON.parse(element.value);
    } catch (error) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'Monitoring' does not exist on type 'Wind... Remove this comment to see the full error message
      window.Monitoring?.NRError(error, 'window.getFormFieldValue');
    }
  }
  return element.value;
};

window.getFormValues = function getFormValues(form_id) {
  const form = window.xGetElementById(form_id);

  if (form) form_id = form.id;

  const key_values = {};

  const elements = window.custGetElementsByClassName(form_id, form) as JQuery<HTMLInputElement>;

  if (!elements || elements.length <= 0) {
    return key_values;
  }

  // @ts-expect-error ts-migrate(6133) FIXME: 'count' is declared but its value is never read.
  let count = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].name) {
      // maybe enable this later
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'dx' does not exist on type 'HTMLInputEle... Remove this comment to see the full error message
      if (elements[i].className.indexOf('savedx') !== -1 && !elements[i].dx) {
        continue;
      }
      if (elements[i].type === 'radio') {
        if (!elements[i].checked) continue;
      }
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      key_values[elements[i].name] = window.getFormFieldValue(elements[i]);
      // eslint-disable-next-line no-plusplus
      count++;
    }
  }
  // key_values.length = count;
  return key_values;
};

window.recurseBuildFormArray = function recurseBuildFormArray(arr, name, value) {
  const index = name.indexOf('.');
  if (index === -1) {
    // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    arr[name] = value;
    return;
  }
  const array_name = name.substring(0, index);
  const field_name = name.substring(index + 1);

  // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
  if (typeof arr[array_name] !== 'object') {
    // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    arr[array_name] = {};
  }
  // @ts-expect-error ts-migrate(7015) FIXME: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
  recurseBuildFormArray(arr[array_name], field_name, value);
};

window.autosizeLoader = function autosizeLoader() {
  $('textarea[autosize]').autosize();
};

$(() => window.autosizeLoader());
